//Third party libraries
import { Link, useLocation } from 'react-router';
//Services
import { useDashboardData } from '../../../hooks/ReactQueryHooks/useDashboardQuery';
//Assets and Miscellaneous
import type { DashboardType } from '../../../types/Analytics';
import { getTdmCompleteOverCount } from '../../../utils/analytics';
//Components
import StatCard from '../../Sherpa/Projects/Project/StatCard/StatCard';
import { Widget } from '../constants';
import WidgetLayout from '../WidgetLayout';

export interface ProjectTypeProps {
  projectType: string;
  _count: number;
}

export default function MilestoneWidget({ dashboard }: { dashboard: DashboardType }) {
  const location = useLocation();
  const fetchMilestonesWidgetData = useDashboardData({
    dashboard,
    widget: Widget.MILESTONES_COUNT,
  });
  const milestonesWidgetData = fetchMilestonesWidgetData?.data?.data;
  const milestonesStat = getTdmCompleteOverCount(milestonesWidgetData);

  return (
    <WidgetLayout dashboard={dashboard} widget={Widget.MILESTONES_COUNT}>
      <Link to={`${location.pathname}/milestones`}>
        <StatCard
          label='Milestones'
          stats={{
            completed: milestonesStat.completeCount,
            total: milestonesStat.totalCount,
          }}
        />
      </Link>
    </WidgetLayout>
  );
}
